import Vue from 'vue';
import Vuex from 'vuex';

import common from './modules/common/store';
import sandbox from './modules/sandbox';
import codeHelp from '@/pages/code-help/store';
import jupyter from './modules/jupyter';
import user from './modules/user';
import survey from './modules/survey';
import note from './modules/note';
import images from './modules/image';
import cascader from './modules/cascader';
import video from './modules/video';
import { IRootState } from './types';
import interactiveVideo from './modules/interactive-video ';

Vue.use(Vuex);

function createStore() {
  return new Vuex.Store<IRootState>({
    modules: {
      common,
      codeHelp,
      sandbox,
      user,
      survey,
      note,
      jupyter,
      images,
      cascader,
      video,
      interactiveVideo
    },
    strict: true
  });
}
export default createStore();
